import { Injectable, NgZone } from '@angular/core';
import { User } from '../services/user';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from '@angular/fire/compat/firestore';
import * as auth from 'firebase/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { ApiService } from "src/app/api.service";
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public currentUser: User | undefined = undefined;
  userData: any; // Save logged in user data

  constructor(
    public afs: AngularFirestore, // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    private apiService: ApiService
  ) {
    /* Saving user data in localstorage when 
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.saveUserDataToLocalStorage(user);
        JSON.parse(localStorage.getItem('user')!);
      } else {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        JSON.parse(localStorage.getItem('user')!);
      }
    });
  }

  private async saveUserDataToLocalStorage(user: any) {
    this.userData = user;
    const token = await user?.getIdToken();
    localStorage.setItem('token', token);
    console.log("getIdToken() returned", token);
    localStorage.setItem('user', JSON.stringify(this.userData));
  }

  SignIn(email: string, password: string) {
    return this.afAuth
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.SetUserData(result.user);
        this.afAuth.authState.subscribe(async (user) => {
          if (user) {
            this.saveUserDataToLocalStorage(user);
            await this.CreateUser();
            //await this.GetCurrentUser();

            if (!user.emailVerified) {
              this.router.navigate(['verify-email-address']);
            } else {
              this.router.navigate(['chat']);
            }
          }
        });
      })
      .catch((error) => {
        console.log("Sign in error:", error)
        window.alert(error.message);
      });
  }

  async GetCurrentUser(): Promise<User | undefined> {
    try {
      const response = await this.apiService.fetch("/current-user", {
        method: "GET"
      });
      this.currentUser = await response.json();
    } catch(error) {
      console.error("GetCurrentUser:", error)
      this.currentUser = undefined;
    };
    
    return this.currentUser
  }

  // Sign up with email/password
  SignUp(email: string, password: string) {
    return this.afAuth
      .createUserWithEmailAndPassword(email, password)
      .then(async (result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
        up and returns promise */
        await this.SetUserData(result.user);
        await this.saveUserDataToLocalStorage(result.user);
        await this.CreateUser();
        await this.SendVerificationMail();
      })
      .catch((error) => {
        window.alert(error.message);
      });
  }

  async CreateUser() {
    await this.apiService.fetch("/sign-up-user", {
      method: "POST"
    });
  }

  // Send email verfificaiton when new user sign up
  SendVerificationMail() {
    return this.afAuth.currentUser
      .then((u: any) => u.sendEmailVerification())
      .then(() => {
        this.router.navigate(['verify-email-address']);
      });
  }
  // Reset Forggot password
  ForgotPassword(passwordResetEmail: string) {
    return this.afAuth
      .sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        window.alert('Password reset email sent, check your inbox.');
      })
      .catch((error) => {
        window.alert(error);
      });
  }
  // Returns true when user is logged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user')!);
    return user !== null && user.emailVerified !== false ? true : false;
  }
  /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  SetUserData(user: any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(
      `users/${user.uid}`
    );
    const userData: User = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified,
    };
    return userRef.set(userData, {
      merge: true,
    });
  }
  // Sign out
  SignOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      this.router.navigate(['site']);
    });
  }


  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    window.location.href = currentUrl;
  }
}